import { RISK_META } from "@/lib/risk";

export default function MetricCard({ label, value, riskKey, isTotal, active, onClick }) {
  const meta = riskKey ? RISK_META[riskKey] : null;
  const topClass = isTotal ? "risk-top-Total" : meta?.topClass || "";
  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative bg-white border rounded-lg p-5 text-left transition-all duration-200 ${topClass} ${
        active
          ? "border-gray-900 shadow-md"
          : "border-gray-200 hover:border-gray-300 hover:shadow-sm"
      }`}
      data-testid={`metric-card-${isTotal ? "total" : meta?.key}`}
    >
      <div className="text-[11px] uppercase tracking-[0.15em] text-gray-500 font-medium">
        {label}
      </div>
      <div className="mt-3 font-display text-[32px] leading-none font-semibold text-gray-900 tabular-nums">
        {value}
      </div>
    </button>
  );
}
